import { useEditorStore } from "@/store";

export function ErrorPanel() {
  const { validationErrors, isErrorPanelOpen, toggleErrorPanel, setSelectedLayerId, setEditorMode, setActiveSection } =
    useEditorStore();

  if (!isErrorPanelOpen || validationErrors.length === 0) return null;

  const handleJumpTo = (error: (typeof validationErrors)[number]) => {
    if (error.layerId) {
      setSelectedLayerId(error.layerId);
      setEditorMode("sections");
      setActiveSection("layers");
    }
  };

  return (
    <div className="shrink-0 border-t border-border-subtle bg-surface-raised">
      <div className="flex items-center justify-between px-3 py-1.5">
        <span className="text-xs font-medium text-error">
          {validationErrors.length} validation error{validationErrors.length > 1 ? "s" : ""}
        </span>
        <button
          type="button"
          onClick={toggleErrorPanel}
          className="text-xs text-text-muted hover:text-text-primary"
        >
          Close
        </button>
      </div>
      <div className="max-h-40 overflow-y-auto px-3 pb-2">
        {validationErrors.map((error, i) => (
          <div
            key={`${error.path}-${i}`}
            className="flex items-start gap-2 rounded-radius-sm px-2 py-1 text-xs hover:bg-surface-sunken"
          >
            <span className="mt-0.5 shrink-0 text-error">●</span>
            <span className="flex-1 text-text-secondary">{error.message}</span>
            {error.layerId && (
              <button
                type="button"
                onClick={() => handleJumpTo(error)}
                className="shrink-0 text-accent hover:text-accent-hover"
              >
                Go to
              </button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
